var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.25H9.5C9.91136 16.25 10.25 16.5886 10.25 17V22C10.25 22.4114 9.91136 22.75 9.5 22.75H2C1.58864 22.75 1.25 22.4114 1.25 22V17C1.25 16.5886 1.58864 16.25 2 16.25ZM14.5 11.25H22C22.4114 11.25 22.75 11.5886 22.75 12V22C22.75 22.4114 22.4114 22.75 22 22.75H14.5C14.0886 22.75 13.75 22.4114 13.75 22V12C13.75 11.5886 14.0886 11.25 14.5 11.25ZM2 1.25H9.5C9.91136 1.25 10.25 1.58864 10.25 2V12C10.25 12.4114 9.91136 12.75 9.5 12.75H2C1.58864 12.75 1.25 12.4114 1.25 12V2C1.25 1.58864 1.58864 1.25 2 1.25ZM14.5 1.25H22C22.4114 1.25 22.75 1.58864 22.75 2V7C22.75 7.41136 22.4114 7.75 22 7.75H14.5C14.0886 7.75 13.75 7.41136 13.75 7V2C13.75 1.58864 14.0886 1.25 14.5 1.25Z",
    stroke: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/dashboardInactive.78ea5a4915b96d69ca88f176d0ab2260.svg";
export { ForwardRef as ReactComponent };